

import { createReducer, on } from "@ngrx/store";
import { allApiLinks, loginDetails, otpVerifiedDetails, userDetails, businessDetails, usersList, selectedUser, localLanguage, permissionData, dashboardDetails, tempararyAddUserFormData, resetLoginAttempts, trackLoginAttempt } from "./auth.actions";
import { initialAuthState } from "./auth.state";


const _authReducer = createReducer(
    initialAuthState,
    on(loginDetails, (state: any, action) => {
        return {
            ...state,
            loginDetails: action.logindata
        }
    }),

    on(trackLoginAttempt, (state, { email }) => {
        console.log(email, state);
        
        const currentTime = Date.now();
        const previousData = state?.attempts?.[email] || { count: 0, lastAttemptTime: 0 };

        // Calculate the time difference between current and last attempt
        const timeDifference = currentTime - previousData.lastAttemptTime;

        // Check if the attempt is within 1 minute
        let updatedCount = previousData.count;
        if (timeDifference < 60000) {
            updatedCount += 1;
        } else {
            updatedCount = 1;
        }
        let attempsts= {
            [email]: {
                count: updatedCount,
                lastAttemptTime: currentTime,
            },
        }
   console.log(attempsts);
   
        return {
            ...state,
            attempts: {
                ...state.attempts,
                [email]: {
                    count: updatedCount,
                    lastAttemptTime: currentTime,
                },
            },
        };
    }),
    on(resetLoginAttempts, (state, { email }) => ({
        ...state,
        attempts: {
            ...state.attempts,
            [email]: { count: 0, lastAttemptTime: 0 },
        },
    })),
    on(otpVerifiedDetails, (state: any, action) => {
        return {
            ...state,
            otpVerifiedDetails: action.otpVerfiedData
        }
    }),
    on(userDetails, (state: any, { data }) => {
        return {
            ...state,
            userDetails: data
        }
    }),
    on(localLanguage, (state: any, { language }) => {
        return {
            ...state,
            localLanguage: language
        }
    }),
    on(businessDetails, (state: any, { data }) => {
        return {
            ...state,
            businessDetails: data
        }
    }),
    on(allApiLinks, (state: any, action) => {
        return {
            ...state,
            allApiLinks: action.data
        }
    }),
    on(usersList, (state: any, action) => {
        return {
            ...state,
            usersList: action.users
        }
    }),
    on(selectedUser, (state: any, action) => {
        return {
            ...state,
            selectedUser: action.selectedUser
        }
    }),

    on(permissionData, (state: any, action) => {
        return {
            ...state,
            permissionData: action.permissionData
        }
    }),

    on(dashboardDetails, (state: any, action) => {
        return {
            ...state,
            dashboardDetails: action.dashboardDetails
        }
    }),

    on(tempararyAddUserFormData, (state: any, action) => {
        return {
            ...state,
            tempararyAddUserFormData: action.tempararyAddUserFormData
        }
    })

)

export function authReducer(state: any, action: any) {
    return _authReducer(state, action)
}
